import { NavigateBackLink } from '@exam-center/components';
import { useParams } from '@exam-center/router';
import { Box, PageHeader } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ExamLocationManagementLayout() {
  const { examCenterCode, requestId, roomRequestId } = useParams(
    '/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId/computer-info',
  );

  return (
    <>
      <PageHeader
        title='รายละเอียดข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId'
            params={{ examCenterCode, requestId, roomRequestId }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <Outlet />
      </Box>
    </>
  );
}
